import React from 'react';
import Navbar from '../components/Internal-nav';  
import ContactBanner from '../components/contact-banner';
import './configure.scss';

function Configure() {


  return (
    <div className='configure-page'>
      <header>
        <Navbar />
      </header>
      <div className='inner-banner' style={{ backgroundImage: "url(../assets/configure-banner.jpg)" }}>
        <div className='banner-content'>
          <h1>Cabinet Configurator</h1>
        </div>
      </div>
      <div className='configurator-container'>
     <iframe id="IfrmEmbedMSI" title="MSI Configurator" scrolling="yes" seamless="seamless" frameBorder="0"
width="100%" height="1025" src="https://www.msisurfaces.com/virtual-kitchen-designer/?menu=n"> </iframe>
      </div>
      <ContactBanner></ContactBanner>
    </div>
  );
}

export default Configure;
